import { useSelector } from 'react-redux';
import { Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { routes } from 'Constants/routes';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import * as Styled from './styles';

const QuizInitial = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  const isPreviousYears = useSelector(routeStateSelector);

  return (
    <Styled.QuizInitialContainer
      direction="column"
      align="center"
      fullWidth
      justify="space-between"
    >
      <Styled.QuizInitialContent
        direction="column"
        fullWidth
        fullHeight
        align="center"
        justify="center"
        gap="dimension_24"
      >
        <FlexContainer
          direction="column"
          fullWidth
          align="center"
          justify="center"
          gap="dimension_08"
        >
          <img src={`${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/balance_s.png`} alt="balance" />
          <Text type="headline" color="dark" size="S_L_M" align="center">
            {t('Quiz.initial.title')}
          </Text>
          <Text type="paragraphs" color="grey" size="S_M_M" align="center">
            {t('Quiz.initial.subtitle')}
          </Text>
        </FlexContainer>
        <Text type="paragraphs" color="fresh" size="M_M_M">
          {t('Quiz.initial.info')}
        </Text>
        <Text type="paragraphs" color="dark" size="M_L_M">
          {t('Quiz.initial.question')}
        </Text>
      </Styled.QuizInitialContent>
      <Styled.ButtonContainer fullWidth align="center" justify="center">
        <Buttons.Classic
          mode="primary"
          label={t('Quiz.initial.button')}
          onClick={() =>
            history.push(routes.DATAGATHERING_QUIZ_FIRST_QUESTION, {
              products: isPreviousYears?.products ?? {},
            })
          }
          size="m"
        />
      </Styled.ButtonContainer>
    </Styled.QuizInitialContainer>
  );
};

export default QuizInitial;
